/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

function headersToObject (headers) {
  let promiseHeaders = {};
  for (var pair of headers.entries()) {
    promiseHeaders[pair[0]] = pair[1];
  }

  return promiseHeaders;
}

export default headersToObject;
